module.exports = __webpack_public_path__ + "img/brave-logo.b16fa21e.webp";